/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./form-item-label.vue?vue&type=template&id=1d5fc62e&scoped=true&"
import script from "./form-item-label.vue?vue&type=script&lang=js&"
export * from "./form-item-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5fc62e",
  null
  
)

export default component.exports